// @ts-strict-ignore
import { Size } from 'src/components/avatar';
import Badge from 'src/components/badge';
import { Element, Section } from 'src/constants/footfall';
import { SupportingMemberEl, SupportingMemberAvatar, SupportingMemberUser, SupportingMemberLink } from 'src/modules/community/communityAbout/components/sharedStyles';
import UserLink from 'src/modules/shared/links/userLink';
export function UserCard({
  username,
  userImageHash,
  role
}) {
  return <SupportingMemberEl data-testid="supporting-member-usercard" data-sentry-element="SupportingMemberEl" data-sentry-component="UserCard" data-sentry-source-file="userCard.tsx">
      <SupportingMemberAvatar data-sentry-element="SupportingMemberAvatar" data-sentry-source-file="userCard.tsx">
        <UserLink avatarSize={Size.Small} signupContext={{
        element: Element.Avatar,
        section: Section.CommunityAbout
      }} user={{
        username,
        userImageHash
      }} data-sentry-element="UserLink" data-sentry-source-file="userCard.tsx" />
      </SupportingMemberAvatar>
      <SupportingMemberUser data-sentry-element="SupportingMemberUser" data-sentry-source-file="userCard.tsx">
        <SupportingMemberLink signupContext={{
        element: Element.UserLink,
        section: Section.CommunityAbout
      }} user={{
        username
      }} data-sentry-element="SupportingMemberLink" data-sentry-source-file="userCard.tsx" />
        <Badge key="user-link-badge" data-sentry-element="Badge" data-sentry-source-file="userCard.tsx">{role}</Badge>
      </SupportingMemberUser>
    </SupportingMemberEl>;
}